export const sendValue = (val) => {
  window.parent.postMessage({ ssn: val }, process.env.REACT_APP_PARENT_URL);
};
